import React from 'react';
import { Countdown, PriceCard } from './Shared';
export const FinalCtaSection = () => {
  return <section className="bg-familia-bg border-t border-familia-cyan/30 py-10 md:py-16 px-4 md:px-6" data-id="element-81">
      <div className="max-w-7xl mx-auto text-center w-[92%] md:w-full" data-id="element-82">
        <h2 className="text-familia-red font-bold text-base sm:text-xl md:text-2xl mb-8 md:mb-12 animate-blink uppercase tracking-widest text-center" data-id="element-83">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>
        <Countdown className="mb-10 md:mb-20" data-id="element-84" />
        <div className="max-w-2xl mx-auto mb-10 md:mb-16 rounded-2xl border border-familia-cyan/25 bg-familia-card p-6 md:p-8 text-left" data-id="element-85">
          <p className="text-white font-display text-xl md:text-2xl font-bold mb-5" data-id="element-86">
            Tienes dos caminos.
          </p>
          <p className="text-familia-gray text-[15px] md:text-base leading-relaxed mb-5" data-id="element-87">
            <span className="text-familia-red font-bold" data-id="element-88">CAMINO A:</span> Seguir
            buscando actividades sueltas cada vez que necesitas una idea y
            organizando el cuidado con información dispersa.
          </p>
          <p className="text-familia-gray text-[15px] md:text-base leading-relaxed mb-5" data-id="element-89">
            <span className="text-familia-green font-bold" data-id="element-90">CAMINO B:</span>{' '}
            Acceder hoy a Vitalidad 360™ y comenzar con una primera actividad o
            rutina adaptada, explicada paso a paso.
          </p>
          <p className="text-white font-bold text-[15px] md:text-base leading-relaxed" data-id="element-91">
            El tiempo compartido con ellos no vuelve.
            <br data-id="element-92" />
            Haz que cada momento tenga una actividad, una conversación o una
            rutina con propósito.
          </p>
        </div>
        <div className="mb-10 md:mb-20 flex justify-center" data-id="element-93">
          <PriceCard data-id="element-94" />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-4xl mx-auto" data-id="element-95">
          {['5 Módulos + Módulo Maestro + 3 Bonos', '+240 páginas de contenido premium', 'Acceso inmediato', 'Garantía 30 días'].map((item, i) => <div key={i} className="bg-familia-card border border-familia-cyan/15 p-4 rounded-xl flex items-center justify-center gap-3" data-id="element-96">
              <span className="text-familia-green" data-id="element-97">✅</span>
              <span className="text-xs font-bold uppercase tracking-wider" data-id="element-98">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
};